// extracted by css-extract-rspack-plugin
export default {"textBlock":"P5h2KZ0zPIMg6ENg","expanded":"LhCwreeuHCkCeyEX","buttonText":"cLl0EvzNuKYcM6Qi"};